import type { MessagingChannelsCopy } from './types';

export const PT_BR: MessagingChannelsCopy = {
  title: 'Mensagens',
  description:
    'Fale com a IMAI pelos apps de chat que você já usa. Conecte uma vez e mande mensagens para a IMAI por lá.',
  privacy:
    'As mensagens das suas contas conectadas são executadas como você neste espaço de trabalho e usam seus créditos.',
  loading: 'Carregando canais de mensagens',
  unavailable: 'Ainda não disponível',
  unavailableNote: '{channel} ainda não está configurado para a IMAI.',
  connectedBadge: 'Conectado',
  cancel: 'Cancelar',

  phoneTitle: 'Número de telefone',
  phoneNote: 'Conecte o WhatsApp ou iMessage com seu número de telefone.',
  phoneUnavailableNote:
    'As mensagens de texto com a IMAI ainda não estão configuradas.',
  addNumber: 'Adicionar número',
  countryLabel: 'Código do país',
  countrySearch: 'Buscar país ou código…',
  countryEmpty: 'Nenhum país encontrado.',
  numberLabel: 'Número de telefone',
  numberPlaceholder: 'Número de telefone',
  numberHint:
    'Seu país não está na lista? Digite o número completo começando com +.',
  continueActivation: 'Continuar',
  editNumber: 'Alterar número',
  activateQr: 'Escaneie e envie para conectar.',
  activateTitle: 'Envie uma mensagem pelo WhatsApp',
  activateHint: 'Toque no botão e envie a mensagem que já vem preenchida.',
  activateSentFrom: 'Envie a partir de {number}.',
  activateButton: 'Abrir {channel}',
  activateManual: 'Ou envie {message} para {number} pelo WhatsApp.',
  activateWaiting: 'Aguardando sua mensagem. Expira em {time}.',
  startAgain: 'Começar de novo',
  verifiedBadge: 'Verificado',
  verifiedOn: 'Verificado em {date}',
  change: 'Alterar',
  changeAria: 'Alterar o número {number}',
  remove: 'Remover',
  removeAria: 'Remover o número {number}',
  messageImai: 'Falar com a IMAI',
  messageImaiAria: 'Falar com a IMAI pelo {channel}',
  removeTitle: 'Remover {number}?',
  removeDescription:
    'A IMAI vai parar de responder a este número no iMessage e no WhatsApp. Você pode adicioná-lo de novo quando quiser.',
  removeError: 'Não foi possível remover o número. Tente de novo.',

  errorInvalidNumber: 'Digite um número válido, com o DDD.',
  errorNumberTaken: 'Este número já é usado por outra conta da IMAI.',
  errorRateLimited: 'Muitas tentativas. Aguarde um pouco e tente de novo.',
  errorChannelUnavailable:
    'Essa opção não está disponível agora. Escolha a outra.',
  errorSendFailed: 'Não foi possível iniciar a verificação. Tente de novo.',
  errorActivationExpired: 'Esta ativação expirou. Comece de novo.',

  noteSlack: 'Mande mensagens para a IMAI do seu espaço de trabalho do Slack.',
  noteTeams: 'Mande mensagens para a IMAI pelo Microsoft Teams.',
  noteTelegram: 'Converse com o bot da IMAI no Telegram.',
  connect: 'Conectar',
  connectAria: 'Conectar {channel}',
  connectError:
    'Não foi possível começar a conectar o {channel}. Tente de novo.',
  connectedOn: 'Conectado em {date}',
  accountFallback: 'Sua conta do {channel}',
  installSlack: 'Adicionar a IMAI ao seu espaço de trabalho',
  installTeams: 'Adicionar a IMAI ao Teams',
  openTelegram: 'Abrir no Telegram',
  disconnect: 'Desconectar',
  disconnectAria: 'Desconectar {account} do {channel}',
  disconnectError: 'Não foi possível desconectar o {channel}. Tente de novo.',
  disconnectTitle: 'Desconectar {channel}?',
  disconnectDescription:
    'As mensagens de {account} vão parar de chegar à IMAI. Você pode conectar de novo quando quiser.',

  toastConnected: '{channel} conectado',
  toastConnectedGeneric: 'Conta conectada',
  toastErrorExpired: 'O login demorou demais. Tente conectar de novo.',
  toastErrorInvalidState:
    'Esse link de login não é mais válido. Tente conectar de novo.',
  toastErrorAccountTaken:
    'Essa conta já está conectada a outro usuário da IMAI.',
  toastErrorNotMember: 'Você não é mais membro deste espaço de trabalho.',
  toastErrorProvider: 'O login não foi concluído. Tente conectar de novo.',
  toastErrorGeneric: 'Não foi possível conectar a conta. Tente de novo.',
};
